/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
/**
 * 複数選択可能なドロップダウンのコンポーネントと、そのコンポーネントが内部で利用するコンポーネント、関数をまとめたファイルです。
 * 参考：
 * https://react-select.com/home
 * https://stackoverflow.com/questions/62795886/returning-correct-value-using-react-select-and-react-hook-form/67427010#67427010
 */
import { useMemo } from 'react';
import { Control, FieldValues, Path, UnPackAsyncDefaultValues } from 'react-hook-form';
import { MultiSelectMain } from '../../atoms/MultiSelect';

interface Props<S, T extends FieldValues> {
  id?: string | undefined;
  name: Path<UnPackAsyncDefaultValues<T>>;
  options: S[];
  control: Control<T>;
  isDisabled: boolean;
  getValue: (x: S) => string | undefined;
  getLabel: (x: S) => string | undefined;
}

/**
 * 複数選択可能なドロップダウンのコンポーネント
 * 基本部分は MultiSelectMain で実装し、こちらでは選択肢のみを生成します。
 * @param
 * @returns
 */
function MultiSelectStringArray<S, T extends FieldValues>({
  id,
  name,
  options,
  control,
  isDisabled,
  getValue,
  getLabel,
}: Props<S, T>) {
  const valueLabelOptions = useMemo(
    () => options.map((x) => ({ value: getValue(x), label: getLabel(x) })),
    [options, getValue, getLabel]
  );

  return (
    <span className="dropdown">
      <MultiSelectMain id={id} name={name} options={valueLabelOptions} control={control} isDisabled={isDisabled} />
    </span>
  );
}

MultiSelectStringArray.defaultProps = {
  id: undefined,
};

export default MultiSelectStringArray;
